import React from 'react';

import './Notification.css';

class Notification extends React.Component {
  
  constructor(props) {
    super(props);

    this._close = this._close.bind(this);

    this.state = {
      hidden:true,
      text:this.props.text || "",
      buttonText:this.props.buttonText || "Close",
      buttonCallback:this.props.buttonCallback || null,
      timeout:this.props.timeout || 4000
    };

  }

  componentWillReceiveProps(newProps) {

    var timeout;

    clearTimeout(timeout);
    if (newProps.text != this.state.text) {
      this.setState({
        text:newProps.text,
        hidden:false
      },function() {
        if (this.state.timeout > 0) {
          timeout = setTimeout(this._close.bind(this),this.state.timeout);
        }
      });
    }

  }

  render() {

    return (
      <div className={this.state.hidden ? "Notification clearfix clearflex hidden" : "Notification clearfix clearflex"}>
        <p>{this.state.text}</p>
        <p style={{marginLeft:"auto"}}><a onClick={this._close}>{this.state.buttonText}</a></p>
        </div>
    );
  }

  _close() {
    this.setState({
      hidden:true
    });
  }

}

export default Notification;


// WEBPACK FOOTER //
// ./src/components/Notification.js